import en from './en';

const messages = {
  en
};

export default messages;
